import { FileUploadComponent } from './shared/file-upload/file-upload.component';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { OnlyNumberDirective } from './shared/directives/numbers-only.directive';
import { OnlyTextDirective } from './shared/directives/text-only.directive';

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { NavBarComponent } from "./shared/nav-bar/nav-bar.component";
import { RouterModule } from "@angular/router";
import { AppRoutes } from "./app.routing";
import { FaqComponent } from "./faq/faq.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { ShopGridComponent } from "./shop-grid/shop-grid.component";
import { LoginComponent } from "./login/login.component";
import { CartComponent } from "./cart/cart.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { WishlistComponent } from "./wishlist/wishlist.component";
import { ErrorPageComponent } from "./error-page/error-page.component";

import { ContactUsComponent } from "./contact-us/contact-us.component";

import { AboutUsComponent } from "./about-us/about-us.component";
import { ProductTileComponent } from "./shared/product-tile/product-tile.component";
import { ProductBlockComponent } from "./shared/product-block/product-block.component";
import { CarouselModule } from "ngx-owl-carousel-o";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SingleProductComponent } from "./single-product/single-product.component";
import { SliderScrollService } from "./ApplicationServices/SliderScrollService";
import { CollectionService } from "./ApplicationServices/CollectionService";
import { ProductDetailsService } from "./ApplicationServices/ProductDetailsService";
import { HttpClientModule } from '@angular/common/http';
import { DeliverytermsComponent } from './deliveryterms/deliveryterms.component';
import { ReturnpolicyComponent } from './returnpolicy/returnpolicy.component';
import { PaymenttermsComponent } from './paymentterms/paymentterms.component';
import { BlogComponent } from './blog/blog.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { SecurityComponent } from './security/security.component';

import { ShopGridDealofthedayComponent } from './shop-grid-dealoftheday/shop-grid-dealoftheday.component';
import { ShopGridBulkorcorporateorderComponent } from './shop-grid-bulkorcorporateorder/shop-grid-bulkorcorporateorder.component';


import { FbShareComponent } from "./shared/social/fbshare.component";
import { TweetComponent } from './shared/social/twittershare.component';
import { PinItComponent } from './shared/social/printerest.component';
import { VisitorsvisionComponent } from './visitorsvision/visitorsvision.component';

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginService } from "./ApplicationServices/LoginService";
import { DropdownComponent } from "./shared/dropdown/dropdown";
import { UserInfoStore } from "./shared/store/userInfo.store";
import { ItemModifierService } from "./ApplicationServices/ItemModifierServices";
import { AddressComponent } from "./address/address.component";

import { OrdersComponent } from './orders/orders.component';


import { ConsignorService } from './ApplicationServices/ConsignorService';
import { ConsigneeService } from './ApplicationServices/ConsigneeService';
import { SharedService } from './ApplicationServices/SharedService';
import { UpdateprofileComponent } from './updateprofile/updateprofile.component';
import { ProceedpaymentComponent } from './proceedpayment/proceedpayment.component';
import { ShippingComponent } from './shipping/shipping.component';
import { CancellationComponent } from './cancellation/cancellation.component';
import { CareersComponent } from './careers/careers.component';
//import { ContactUsComponent } from './contact-us/contact-us.component';

import { WindowRef } from "./ApplicationServices/WindowRefService";
import { ConditionsofUseComponent } from './conditionsof-use/conditionsof-use.component';
import { RefundsOrCancellationsComponent } from './refunds-or-cancellations/refunds-or-cancellations.component';
import { ThankingYouForShoppingComponent } from './+Admin/thanking-you-for-shopping/thanking-you-for-shopping.component';
import { ThankingyouComponent } from './thankingyou/thankingyou.component';

import { HideandskincustomizationComponent } from './hideandskincustomization/hideandskincustomization.component';
import { HideandskindemandComponent } from './hideandskindemand/hideandskindemand.component';
import { CustomeropinionComponent } from './customeropinion/customeropinion.component';
import { HideandskincustomeropinionComponent } from './hideandskincustomeropinion/hideandskincustomeropinion.component';
import { ProTileComponent } from './shared/pro-tile/pro-tile.component';
import { SearchproductsComponent } from './searchproducts/searchproducts.component';
import { HeaderComponent } from './header/header.component';
import { SearchBarComponent } from './search-bar/search-bar.component';

import { ExcelService } from '../app/ApplicationServices/excel.service';

import { ItemMasterBasic2_VariationService } from "../app/ApplicationServices/ItemMasterBasic2_VariationService";
import { RegistrationBasicService } from '../app/ApplicationServices/RegistrationBasicService';
import { RegistrationFeedbackService } from '../app/ApplicationServices/RegistrationFeedbackService';
import { RegistrationHealthService } from '../app/ApplicationServices/RegistrationHealthService';
///import { SharedService } from '../app/ApplicationServices/SharedService';
import { PopUpService } from '../app/ApplicationServices/PopUpService';
import { UploadService } from '../app/ApplicationServices/UploadService';

import { ImageService } from '../app/ApplicationServices/ImageService';
import { BranchService } from '../app/ApplicationServices/BranchService';
import { CompanyService } from '../app/ApplicationServices/CompanyService';

import { ItemMasterHeaderSubDescService } from '../app/ApplicationServices/ItemMasterHeaderSubDescService';

import { ItemMasterBasic10_EarningPtsGeneratorService } from "../app/ApplicationServices/ItemMasterBasic10_EarningPtsGeneratorService";
import { ItemMasterBasic1_VitalService } from "../app/ApplicationServices/ItemMasterBasic1_VitalService";
///  ImageService, BranchService, CompanyService



@NgModule({
  declarations: [
    AppComponent,
    FileUploadComponent,
    HomeComponent,
    NavBarComponent,
    FaqComponent,
    FooterComponent,
    ShopGridComponent,
    LoginComponent,
    CartComponent,
    CheckoutComponent,
    WishlistComponent,
    ErrorPageComponent,
    ContactUsComponent,
    AboutUsComponent,
    ProductTileComponent,
    ProductBlockComponent,
    SingleProductComponent,
    DeliverytermsComponent,
    ReturnpolicyComponent,
    PaymenttermsComponent,
    BlogComponent,
    PrivacypolicyComponent,
    SecurityComponent,
    ShopGridDealofthedayComponent,
    ShopGridBulkorcorporateorderComponent,
    FbShareComponent,
    TweetComponent,
    PinItComponent,
    VisitorsvisionComponent,
    DropdownComponent,
    AddressComponent,

    OnlyNumberDirective,
    OnlyTextDirective,HeaderComponent,SearchBarComponent,
    OrdersComponent, UpdateprofileComponent, ProceedpaymentComponent, ShippingComponent,
    CancellationComponent, CareersComponent, ContactUsComponent, ConditionsofUseComponent, RefundsOrCancellationsComponent, ThankingYouForShoppingComponent, ThankingyouComponent, 
    HideandskincustomizationComponent,HideandskindemandComponent, CustomeropinionComponent, HideandskincustomeropinionComponent, ProTileComponent, SearchproductsComponent

  ],
  imports: [

      NgbModule,
      CarouselModule,
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      HttpClientModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule.forRoot(AppRoutes, {
      useHash: true,

    }),
  ],
  providers:
  [

    SliderScrollService,
    CollectionService,
    ProductDetailsService,
    LoginService,
    UserInfoStore,
    ItemModifierService,
    ConsignorService,ConsigneeService,SharedService, WindowRef,ExcelService,
    UploadService,PopUpService,
    ItemMasterBasic2_VariationService,
    RegistrationBasicService, RegistrationFeedbackService, RegistrationHealthService,
    ImageService, BranchService, CompanyService, ItemMasterHeaderSubDescService,
    ItemMasterBasic10_EarningPtsGeneratorService, ItemMasterBasic1_VitalService

  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
